import { all, fork } from 'redux-saga/effects';

import watchCheckoutAddressRequest from './checkoutAddressRequest';
import watchCheckoutRequest from './checkoutRequest';
import watchConfirmation from './confirmation';
import watchCreateBillet from './createBillet';
import watchGetPaymentTypes from './getPaymentTypes';
import watchPixPaymentRequest from './pixPaymentRequest';
import watchSelectFinancing from './selectFinancing';
import watchSelectPayment from './selectPayment';
import watchSendPayment from './sendPayment';

function* checkoutSagas() {
  yield all([
    fork(watchCheckoutRequest),
    fork(watchCheckoutAddressRequest),
    fork(watchSelectPayment),
    fork(watchGetPaymentTypes),
    fork(watchSelectFinancing),
    fork(watchSendPayment),
    fork(watchConfirmation),
    fork(watchCreateBillet),
    fork(watchPixPaymentRequest),
  ]);
}

export default checkoutSagas;
